import { GoogleMap, InfoWindow, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import React, { Component } from 'react';

import Autocomplete from 'react-google-autocomplete';
import Geocode from 'react-geocode';
import { GoogleMapsAPI } from '../client-config';
import { images } from 'src/assets/img';
import searchIcon from 'src/assets/img/SalesForce_Icon/SearchIcon.svg';

Geocode.setApiKey('AIzaSyCv0JT6W6tMYCww1FnEjf6CxaKUFIhbNdA');
Geocode.enableDebug();

class MapEmirateSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			area: props.deliveryInfoData?.area,
		};
	}

	getAreaEmirate = (addressArray) => {
		let area = '';
		for (let i = 0; i < addressArray.length; i++) {
			if (addressArray[i].types[0]) {
				for (let j = 0; j < addressArray[i].types.length; j++) {
					if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
						area = addressArray[i].long_name;
						// this.setState({ area: area });
						return area;
					}
				}
			}
		}
	};
	onAreaSelected = (place) => {
		try {
			let addressArray = place.address_components,
				area = this.getAreaEmirate(addressArray);
			this.setState({
				area: place?.name,
			});
			this.props.setArea(place?.name);
		} catch (error) {
			console.log(error);
		}
	};
	render() {
		const AsyncMap = withScriptjs(
			withGoogleMap((props) => (
				<Autocomplete
					style={{
						width: '100%',
						outline: 'none',
					}}
					className="search-emirate"
					onPlaceSelected={this.onAreaSelected}
					placeholder="Area"
					language="english"
					options={{
						// types: ['(regions)'],
						types: ['geocode', 'establishment'],
						componentRestrictions: { country: 'AE' },
						fields: [
							'address_components',
							'adr_address',
							'geometry.location',
							'place_id',
							'formatted_address',
							'business_status',
							'formatted_phone_number',
							'international_phone_number',
							'name',
						],
					}}
					inputAutocompleteValue={this.state.area}
					defaultValue={this.state.area}></Autocomplete>
			))
		);
		let map;
		if (this.props.lat !== undefined) {
			map = (
				<>
					<div>
						<AsyncMap
							googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GoogleMapsAPI}&libraries=places`}
							loadingElement={<div style={{ height: this.props.height }} />}
							containerElement={<div />}
							mapElement={<div style={{ height: `0%`, display: 'none' }} />}
						/>
					</div>
				</>
			);
		} else {
			map = <div style={{ height: this.props.height }} />;
		}
		return map;
	}
}
export default MapEmirateSearch;
